import { dispatchSnackbarSuccess } from "../utils/toaster";

const useAuth = () => {
  const signOut = () => {
    localStorage.clear();
    window.location.href = "/auth/login";
    dispatchSnackbarSuccess("Successfully Logout", "success");
  };

  return { signOut };
};

export default useAuth;
